module.exports = __webpack_public_path__ + "static/media/Hair_2_blond.74543346.svg";